import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { supabase } from '../lib/supabase';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) navigate('/admin', { replace: true });
    });
  }, [navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error: authError } = await supabase.auth.signInWithPassword({ email, password });

    if (authError) {
      setError('Vale e-mail või parool. Proovi uuesti.');
      setLoading(false);
    } else {
      navigate('/admin', { replace: true });
    }
  };

  return (
    <>
      <Helmet>
        <title>Admin — Tõuks</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center p-4 relative">
        {/* Same animated background as the shop */}
        <div className="geometric-bg" />
        <div className="scooter-pattern" />
        <div className="dynamic-lines" />
        <div className="scooter-tracks" />

        <div className="w-full max-w-sm relative z-10">
          <div className="text-center mb-8">
            <img
              src="https://kvantis.ee/Touks.png"
              alt="Tõuks"
              className="h-14 mx-auto"
            />
            <p className="text-gray-500 text-sm mt-3">Haldusdashboard</p>
          </div>

          <div className="bg-white/80 backdrop-blur-md rounded-2xl p-8 shadow-xl border border-gray-200">
            <form onSubmit={handleLogin} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1.5">
                  E-mail
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full bg-white border border-gray-300 text-gray-900 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent transition"
                  placeholder="admin@touks.ee"
                  required
                  autoFocus
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1.5">
                  Parool
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  className="w-full bg-white border border-gray-300 text-gray-900 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent transition"
                  placeholder="••••••••"
                  required
                />
              </div>

              {error && (
                <div className="bg-red-50 border border-red-300 rounded-xl px-4 py-3">
                  <p className="text-red-600 text-sm">{error}</p>
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#4FC1E9] hover:bg-[#3ba8d0] text-white font-bold py-3 rounded-xl transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Sisselogimine...' : 'Logi sisse'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
